module.exports = __webpack_public_path__ + "img/mp-flows-lift.e8ddb56a.jpg";